import { FC, ReactElement, useState } from 'react';

import { updateBebyggelseobjektUtkast } from 'store/bebyggelseobjektUtkastSlice';
import { deleteUtkast } from 'store/utkastSlice';

import { useAppDispatch } from 'hooks/defaultStoreHooks';
import { useDialog } from 'hooks/useDialog';

import { RaaDialog } from 'raa-react';

import { useReserveBebyggelseutkastMutation } from 'api/endpoints/reservationSlice';

const DeleteUtkastDialog: FC<{ utkastId: string }> = ({ utkastId }): ReactElement => {
  const dispatch = useAppDispatch();
  const { unsetDialog } = useDialog();
  const [error, setError] = useState(false);
  const [deleting, setDeleting] = useState(false);

  const [patchReservation, results] = useReserveBebyggelseutkastMutation();
  const { isError: patchingReservationIsError } = results;

  const handleDelete = async (id: string): Promise<void> => {
    setError(false);
    setDeleting(true);

    await patchReservation({ id, reserve: true });

    if (patchingReservationIsError) {
      setDeleting(false);
      setError(true);
    } else {
      const deleteResponse = await dispatch(deleteUtkast(id));

      if (deleteResponse.meta.requestStatus === 'fulfilled') {
        setError(true);
        setDeleting(false);
        dispatch(updateBebyggelseobjektUtkast(id));
      } else {
        await patchReservation({ id, reserve: false });
        setError(true);
        setDeleting(false);
      }
    }
    unsetDialog();
  };

  return (
    <RaaDialog
      cancel={unsetDialog}
      proceed={error ? undefined : () => handleDelete(utkastId)}
      close={!deleting ? unsetDialog : undefined}
      header={error ? 'Något gick fel!' : 'Vill du radera utkastet?'}
      proceedButtonText="radera"
      cancelButtonText={error ? 'Stäng' : 'avbryt'}
      showLoadingSpinner={deleting}
    />
  );
};

export default DeleteUtkastDialog;
